import React from "react";
import "./styles.scss";
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
import hv_player_api from "../../../../api/hv_player_api";

export const a = momentDurationFormatSetup;

export default ({
  progress,
  duration = 0,
  showTimeUnderBar,
  className,
  disabled,
}) => {
  const _progress = progress
    ? progress
    : { loaded: 0, played: 0, playedSeconds: 0 };
  const _loaded = _progress.loaded * 100;
  const _played = _progress.played * 100;

  const _playedTime = moment
    .duration(_progress.playedSeconds * 1000)
    .format("mm:ss", { trim: false });
  const _duration = moment
    .duration(duration * 1000)
    .format("mm:ss", { trim: false });
  const _durationSeconds = moment
    .duration(duration * 1000)
    .format("ss", { trim: false });
  const _playedSeconds = moment
    .duration(_progress.playedSeconds * 1000)
    .format("ss", { trim: false });
  const rangeBackground = `linear-gradient(to right, #01a0c6 0%, #01a0c6 ${_played}%, #333 ${_played}%, #333 ${_loaded}%, #ecebed ${_loaded}%, #ecebed 100%)`;
  const seek = (event) => {
    const seekRatio = event.target.value / _durationSeconds.replace(/,/g , '');
    hv_player_api.seek(seekRatio);
  };

  return (
    <div
      className={`hv-progress ${className ? className : ""} ${
        showTimeUnderBar ? "flex-column position-relative time-below" : ""
      } ${disabled && "disabled"}`}
    >
      {showTimeUnderBar ? (
        <>
          <span className="hv-bar">
            <input
              type="range"
              className="hv-bar-range"
              min={0}
              max={_durationSeconds}
              value={_playedSeconds}
              style={{
                background: rangeBackground,
              }}
              onChange={seek}
            />
          </span>
          <div className="time d-flex justify-content-between">
            <span>{_playedTime}</span>
            <span>{_duration}</span>
          </div>
        </>
      ) : (
        <>
          <span className="hv-bar-time">{_playedTime}</span>
          <span className="hv-bar bottom">
            <input
              type="range"
              className="hv-bar-range"
              min={0}
              max={_durationSeconds}
              value={_playedSeconds}
              style={{
                background: rangeBackground,
              }}
              onChange={seek}
            />
          </span>
          <span className="hv-bar-time">{_duration}</span>
        </>
      )}
    </div>
  );
};
